import React from 'react';
import { themr } from 'react-css-themr';
import { CdnContext } from '../../context';

import baseFeelingstheme from './Feelings.scss';

const len = v => (v ? v.length : 0);

class Feelings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            feelings: {
                positief: {},
                negatief: {},
            },
        };
    }

    componentWillMount() {
        this.setInitialAnswer();
    }

    componentWillUnmount() {
        const { part, section, setAnswer } = this.props;
        const { feelings } = this.state;

        setAnswer({
            part,
            section,
            answer: feelings,
        });
    }

    setInitialAnswer() {
        const { answer, onStateChange } = this.props;

        if (
            Object.keys(this.state.feelings).length === 0 &&
            answer &&
            Object.keys(answer).length > 0
        ) {
            this.setState({
                feelings: answer,
            });
            onStateChange(true);
        }
    }

    validState() {
        const { feelings } = this.state;
        const { dependData } = this.props;

        if (
            Object.keys(feelings.positief).length < dependData.positief.length
        ) {
            return false;
        }

        if (
            Object.keys(feelings.negatief).length < dependData.negatief.length
        ) {
            return false;
        }

        if (Object.values(feelings.positief).find(val => val === '') > -1) {
            return false;
        }

        if (Object.values(feelings.negatief).find(val => val === '') > -1) {
            return false;
        }

        return true;
    }

    handleFeelingChange = (evt, key, feeling) => {
        const { feelings } = this.state;
        const { onStateChange } = this.props;

        feelings[key][feeling] = evt.target.value;

        this.setState(
            {
                feelings,
            },
            () => onStateChange(this.validState())
        );
    };

    render() {
        const {
            dependData: data = {},
            placeholders,
            theme,
            header,
        } = this.props;
        const { feelings } = this.state;

        return (
            <div className={`${theme.feelings}`}>
                <h2 className="question-heading">{header.title}</h2>
                <div className="question-description">
                    <p>{header.description}</p>
                </div>
                <div className="row">
                    <div className="col-md">
                        {data.positief &&
                            data.positief.map((word, index) => (
                                <div
                                    key={word.word}
                                    className={`${theme.inputs} form-group row`}
                                >
                                    <CdnContext.Consumer>
                                        {cdn => (
                                            <label
                                                className="col-12"
                                                htmlFor={word.word}
                                            >
                                                {word.icon && (
                                                    <img
                                                        src={`${cdn}assets/images/emoticons/${
                                                            word.filename
                                                        }`}
                                                        alt={word.word}
                                                    />
                                                )}{' '}
                                                {word.word}:
                                            </label>
                                        )}
                                    </CdnContext.Consumer>

                                    <div className="col-12">
                                        <input
                                            name={word.word}
                                            type="text"
                                            className="form-control"
                                            value={feelings[word.word]}
                                            placeholder={
                                                placeholders.positief[index]
                                            }
                                            onChange={(e) => {
                                                this.handleFeelingChange(
                                                    e,
                                                    'positief',
                                                    word.word
                                                );
                                            }}
                                            minLength={1}
                                            maxLength={30}
                                        />
                                        <small className="form-text text-muted float-right">
                                            {len(feelings.positief[word.word])}
                                            /30
                                        </small>
                                    </div>
                                </div>
                            ))}
                    </div>
                    <div className="col-md">
                        {data.negatief &&
                            data.negatief.map((word, index) => (
                                <div
                                    key={word.word}
                                    className={`${theme.inputs} form-group row`}
                                >
                                    <CdnContext.Consumer>
                                        {cdn => (
                                            <label
                                                className="col-12"
                                                htmlFor={word.word}
                                            >
                                                {word.icon && (
                                                    <img
                                                        src={`${cdn}assets/images/emoticons/${
                                                            word.filename
                                                        }`}
                                                        alt={word.word}
                                                    />
                                                )}{' '}
                                                {word.word}:
                                            </label>
                                        )}
                                    </CdnContext.Consumer>
                                    <div className="col-12">
                                        <input
                                            name={word.word}
                                            type="text"
                                            className="form-control"
                                            value={feelings[word.word]}
                                            placeholder={
                                                placeholders.negatief[index]
                                            }
                                            onChange={(e) => {
                                                this.handleFeelingChange(
                                                    e,
                                                    'negatief',
                                                    word.word
                                                );
                                            }}
                                            minLength={1}
                                            maxLength={30}
                                        />

                                        <small className="form-text text-muted float-right">
                                            {len(feelings.negatief[word.word])}
                                            /30
                                        </small>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default themr('Feelings', baseFeelingstheme)(Feelings);



// WEBPACK FOOTER //
// ./src/components/questions/Feelings.js